import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'total']
  static values = {
    numberOfEmployees: { type: Number, default: 0 },
    familyImpact: { type: Number, default: 0 }
  }

  calculate() {
    const inputSum = this.inputTargets.reduce((total, input) => {
      const value = parseInt(input.value) || 0
      return total + value
    }, 0)

    const total = inputSum + this.numberOfEmployeesValue + this.familyImpactValue

    this.totalTarget.textContent = total
  }
}
